export default "__VITE_ASSET__9fb5bcd1__"